// extracted by mini-css-extract-plugin
export default {"tooltip":"UserActions-module__tooltip___bsNl7","wrapper":"UserActions-module__wrapper___TFkcx"};